// Success Screen Component - Shows successful import results
import { t } from '../../../i18n.js';

export class SuccessScreen {
  constructor(wizard) {
    this.wizard = wizard;
  }
  
  async show(response, attachmentResults) {
    try {
      const { getInstance } = await this.wizard.getAuthInstance();
      const instance = getInstance();
      const baseUrl = `https://${instance}.assistgo.de`;
      this.render(response, attachmentResults, baseUrl);
    } catch (error) {
      // Fallback without CRM link
      this.render(response, attachmentResults, '#');
    }
  }
  
  render(response, attachmentResults, baseUrl) {
    const isAppointment = this.wizard.item.itemType === Office.MailboxEnums.ItemType.Appointment;
    const successTitle = isAppointment ? t('event_added_title') : t('email_added_title');
    const subtitle = isAppointment ? t('event_saved_subtitle') : t('email_saved_subtitle');
    const subjectFull = response?.subject || '';
    const senderFull = response?.senderEmail || '';
    const truncate = (value, max = 30) => {
      const str = typeof value === 'string' ? value : String(value || '');
      if (str.length <= max) return str;
      return str.slice(0, Math.max(0, max - 1)) + '…';
    };
    const subjectShort = truncate(subjectFull, 30);
    const senderShort = truncate(senderFull, 30);
    
    this.wizard.container.innerHTML = `
      <div class="success-screen">
        <div class="success-header">
          <span class="success-icon">✅</span>
          <h3>${successTitle}</h3>
          <p class="success-subtitle">${subtitle}</p>
        </div>
        
        <div class="success-details">
          <div class="success-summary">
            ${subjectFull ? `<p><strong>${t('subject_label')}</strong> <span class="truncate" title="${subjectFull}">${subjectShort}</span></p>` : ''}
            ${senderFull ? `<p><strong>${t('from_label')}</strong> <span class="truncate" title="${senderFull}">${senderShort}</span></p>` : ''}
            ${response?.createdAt ? `<p><strong>${t('date_label')}</strong> <span>${new Date(response.createdAt).toLocaleString()}</span></p>` : ''}
            <p><strong>${t('contacts_label')}</strong> <span>${this.wizard.selectedContacts.length}</span></p>
            ${this.wizard.selectedLead ? `<p><strong>${t('lead_result_label')}</strong> <span>${t('linked')}</span></p>` : ''}
            ${this.wizard.selectedCampaign ? `<p><strong>${t('campaign_result_label')}</strong> <span>${t('selected')}</span></p>` : ''}
            ${attachmentResults && attachmentResults.totalProcessed > 0 ? 
              `<p><strong>${t('attachments_label')}</strong> <span>${attachmentResults.totalProcessed} ${t('uploaded')}</span></p>` : ''}
          </div>
        </div>
        
        <div class="success-actions">
          <a href="${baseUrl}/activity/${response.activity}/details" target="_blank" class="wizard-btn wizard-btn-primary">
            ${t('view_in_crm')}
          </a>
          <button onclick="window.location.reload()" class="wizard-btn wizard-btn-secondary">
            ${t('import_another')}
          </button>
        </div>
      </div>
    `;
  }
}
